// @ts-nocheck
import * as React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import type { StatelessFunctionalComponent } from 'react';
import { TABLET_WIDTH, CELLPHONE_LARGE_WIDTH } from 'commons/constants';

export const Wrapper: StatelessFunctionalComponent<any> = styled.div`
  background: ${(props) => props.theme.palette.greyscale.white};
  max-width: 1024px;
  display: block;
  margin-left: auto;
  margin-right: auto;

  & > * {
    display: flex;
    flex-grow: 1;
  }
`;
export const Content: StatelessFunctionalComponent<any> = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: center;
  border-top: ${(props) => props.theme.noodera.spacing.x8} solid
    ${(props) => props.theme.palette.primary.hundred};
  margin: ${(props) => props.theme.noodera.spacing.x5} ${(props) => props.theme.noodera.spacing.x3}
    ${(props) => props.theme.noodera.spacing.x3};

  @media only screen and (max-width: ${TABLET_WIDTH}px) {
    margin: ${(props) => props.theme.noodera.spacing.x5}
      ${(props) => props.theme.noodera.spacing.x4} 10.4rem;
  }

  @media only screen and (max-width: ${CELLPHONE_LARGE_WIDTH}px) {
    margin: ${(props) => props.theme.noodera.spacing.x5}
      ${(props) => props.theme.noodera.spacing.x5} 10.4rem;
  }

  .be-ix-link-block {
    margin-bottom: ${(props) => props.theme.noodera.spacing.x3};

    .be-related-link-container {
      margin: 0;
      padding: 0;
      display: unset;

      .be-label {
        ${(props) => props.theme.noodera.fontTypes.font5Medium};
        color: ${(props) => props.theme.palette.neutral.hundred};
        letter-spacing: 0;
        margin: 0;
        display: inline;
        text-transform: unset;
      }

      .be-list {
        display: inline;

        .be-list-item {
          margin: 0 0 0 ${(props) => props.theme.noodera.spacing.x7};
          padding-left: ${(props) => props.theme.noodera.spacing.x7};
          border-left: 1px solid ${(props) => props.theme.palette.neutral.twenty};
          display: inline;

          .be-related-link {
            ${(props) => props.theme.noodera.fontTypes.font5};
            ${(props) => props.theme.underlineNeutralLink};
            color: ${(props) => props.theme.palette.neutral.hundred};
            line-height: 2.4rem;
          }
        }
      }
    }
  }
`;
export const LinksContainer: StatelessFunctionalComponent<any> = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  margin: ${(props) => props.theme.noodera.spacing.x3} 0;

  & > div {
    width: 33%;
  }

  @media only screen and (max-width: ${CELLPHONE_LARGE_WIDTH}px) {
    flex-direction: column;

    & > div {
      width: 100%;
    }
  }
`;
export const Column: StatelessFunctionalComponent<any> = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  @media only screen and (max-width: ${CELLPHONE_LARGE_WIDTH}px) {
    margin: ${(props) => props.theme.noodera.spacing.x3} 0;
  }
`;
export const Company: StatelessFunctionalComponent<any> = styled.div`
  margin-top: ${(props) => props.theme.noodera.spacing.x3};
`;
export const Row: StatelessFunctionalComponent<any> = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;

  @media only screen and (max-width: ${TABLET_WIDTH}px) {
    flex-direction: column;
  }
`;
export const CopyrightSection: StatelessFunctionalComponent<any> = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  margin-top: ${(props) => props.theme.noodera.spacing.x3};

  & > div {
    margin: 0 0 0 ${(props) => props.theme.noodera.spacing.x7};
    padding-left: ${(props) => props.theme.noodera.spacing.x7};
    border-left: 1px solid ${(props) => props.theme.palette.neutral.twenty};
  }

  @media only screen and (max-width: ${TABLET_WIDTH}px) {
    order: 2;
  }

  @media only screen and (max-width: ${CELLPHONE_LARGE_WIDTH}px) {
    flex-wrap: wrap;
  }
`;
export const CopyrightCompany: StatelessFunctionalComponent<any> = styled.span`
  ${(props) => props.theme.noodera.fontTypes.font5};
  color: ${(props) => props.theme.palette.neutral.hundred};

  @media only screen and (max-width: ${CELLPHONE_LARGE_WIDTH}px) {
    margin-bottom: ${(props) => props.theme.noodera.spacing.x7};
  }
`;
export const StyledItem = styled((props) => <Link {...props} />)`
  ${(props) => props.theme.noodera.fontTypes.font5};
  ${(props) => props.theme.underlineNeutralLink};

  @media only screen and (max-width: ${CELLPHONE_LARGE_WIDTH}px) {
    margin-bottom: ${(props) => props.theme.noodera.spacing.x7};
  }
`;
export const ItemHolder: StatelessFunctionalComponent<any> = styled.div`
  margin-bottom: ${(props) => props.theme.noodera.spacing.x7};

  &:last-child {
    margin-bottom: 0;
  }
`;
export const ListContainer: StatelessFunctionalComponent<any> = styled.div`
  display: flex;
  flex-direction: column;
`;
export const ListHeader: StatelessFunctionalComponent<any> = styled.div`
  ${(props) => props.theme.noodera.fontTypes.font4Medium};
  color: ${(props) => props.theme.palette.neutral.hundred};
  text-transform: capitalize;
  margin-bottom: ${(props) => props.theme.noodera.spacing.x5};
`;
export const ContactSupportButtonLink: StatelessFunctionalComponent<any> = styled.button`
  ${(props) => props.theme.noodera.fontTypes.font5};
  ${(props) => props.theme.underlineNeutralLink};
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: inline;
  margin: 0;
  padding: 0;

  @media only screen and (max-width: ${CELLPHONE_LARGE_WIDTH}px) {
    margin-bottom: ${(props) => props.theme.noodera.spacing.x7};
  }
`;
